export default __webpack_public_path__ + "b295ce2.mp3";